import { Component, OnInit } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { roles } from 'src/app/Enums/roles';
import { CustomerOrderDetail } from 'src/app/models/customer/customer.model';
import { WarrantyDetailsModel } from 'src/app/models/product/productAssets.modal';
import { AdminOrderListService } from 'src/app/services/admin-order-list.service';
import { CustomerService } from 'src/app/services/customer.service';
import { WarrantyServiceService } from 'src/app/services/warranty-service.service';

@Component({
  selector: 'app-product-warranty-description',
  templateUrl: './product-warranty-description.component.html',
  styleUrls: ['./product-warranty-description.component.css']
})
export class ProductWarrantyDescriptionComponent implements OnInit {

  Loader: boolean = false;
  ProductId: string;
  WarrantyId: string;
  warrantyServiceItem: WarrantyDetailsModel = new WarrantyDetailsModel();
  customerOrders: CustomerOrderDetail = new CustomerOrderDetail();
  adminOrdersVM: CustomerOrderDetail = new CustomerOrderDetail();

  constructor(private _warrantyServiceService: WarrantyServiceService, private _adminOrderListService: AdminOrderListService,private modalService: NgbModal, private customerService: CustomerService) {
    this.ProductId = localStorage.getItem('ProductId');
    this.WarrantyId = localStorage.getItem('WarrantyDescription');
  }

  ngOnInit() {
    if (localStorage.getItem('role') == roles.Admin.toString()) {
      this.getAdminorderDetail();
    }
    else {
      this.ProductWarrantyDetails();
    }
   
  }

  ProductWarrantyDetails() {
    this.Loader = true;
    this.warrantyServiceItem.warrantyId = +this.WarrantyId
    this.customerOrders.id = +this.ProductId;
    if (this.warrantyServiceItem.warrantyId) {
      this._warrantyServiceService.ProductWarrantyServiceList(this.warrantyServiceItem)
        .subscribe(response => {
          var responseBody = JSON.parse(response._body);
          this.Loader = false;
          if (responseBody.isSuccess) {
            this.warrantyServiceItem = responseBody.responseData;
            localStorage.removeItem("WarrantyDescription")
            setTimeout(() => {
              this.showFeatureEditorValue();
            }, 100);
          }
        });
    } else {
      this.Loader = true;
      this.customerService.GetCustomerOrderDetail(this.customerOrders.id)
        .subscribe(response => {
          var responseBody = JSON.parse(response._body);
          this.Loader = false;
          if (responseBody.isSuccess) {
            this.customerOrders = responseBody.responseData;
            setTimeout(() => {
              this.showFeatureEditorValue();
            }, 100);
          }
        });
    }
  }

   getAdminorderDetail(){
    this.adminOrdersVM.id = +this.ProductId;
    this.Loader = true;
    this._adminOrderListService.getAdminOrderDetail(this.adminOrdersVM.id)
    .subscribe((response) => {
      this.Loader = false;
      var responseBody = JSON.parse(response._body);
      if (responseBody.isSuccess) {
        this.adminOrdersVM = responseBody.responseData;
        setTimeout(() => {
          this.showFeatureEditorValue();
        }, 100);
   }})}

  showFeatureEditorValue() {
    this.warrantyServiceItem.warrantyId = +this.WarrantyId;
    if (localStorage.getItem('role') == roles.Admin.toString()) {
      var featureElement: HTMLIFrameElement = document.getElementById('productwarrantyFeatures') as HTMLIFrameElement;
      featureElement.innerHTML = this.adminOrdersVM.warrantyServiceTerm;
    }
    else {
      if (this.warrantyServiceItem.warrantyId) {
        var featureElement: HTMLIFrameElement = document.getElementById('productwarrantyFeatures') as HTMLIFrameElement;
        featureElement.innerHTML = this.warrantyServiceItem.warrantyServiceTerm;
      } else {
        var featureElement: HTMLIFrameElement = document.getElementById('productwarrantyFeatures') as HTMLIFrameElement;
        featureElement.innerHTML = this.customerOrders.warrantyServiceTerm;
      }
    }
    }

  onCancel() {
    this.modalService.dismissAll();
  }

}
